import FluxvetLogo from "@/assets/fluxmed-logo-horizontal-white.png";
import { currentFeatures } from "@/configs/Settings";

import { HeaderImage } from "./HeaderImage";

export function HeaderBrand() {
  if (currentFeatures?.defaultApp) {
    return <HeaderImage />;
  }

  return (
    <img src={FluxvetLogo} alt="Fluxvet Logo" style={{ height: "60px" }} />
  );
}
